<template>
    <div class="dashboard">
      <h2>Genel Durum</h2>
      <div class="ga-button-wrapper">
        <button class="ga-button" @click="goToAnalytics">Google Analytics'e Git</button>
      </div>
      <div class="stats-grid">
        <div class="stat-box">
          <span class="label">Toplam Kullanıcı</span>
          <span class="value">{{ stats.users }}</span>
        </div>
        <div class="stat-box">
          <span class="label">Toplam Tercüman</span>
          <span class="value">{{ stats.translators }}</span>
        </div>
        <div class="stat-box">
          <span class="label">Bekleyen İşler</span>
          <span class="value">{{ stats.pendingJobs }}</span>
        </div>
        <div class="stat-box">
          <span class="label">Tamamlanan İşler</span>
          <span class="value">{{ stats.completedJobs }}</span>
        </div>
      </div>
      <DashboardStatsChart />
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted } from 'vue'
  import { getToken } from '@/utils/auth'
  import DashboardStatsChart from '@/components/DashboardStatsChart.vue'
  const baseURL = process.env.VUE_APP_API_URL
  
  const stats = ref({
    users: 0,
    translators: 0,
    pendingJobs: 0,
    completedJobs: 0
  })
  function goToAnalytics() {
  window.open('https://analytics.google.com/analytics/web/', '_blank')
}
  
  async function fetchStats() {
    const res = await fetch(`${baseURL}/admin/stats`, {
      headers: {
        Authorization: `Bearer ${getToken()}`
      }
    })
    stats.value = await res.json()
  }
  
  onMounted(fetchStats)
  </script>
  
  <style scoped>
  .dashboard {
    padding: 40px;
  }
  
  .stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 20px;
    margin-top: 20px;
  }
  
  .stat-box {
    background: #f1f1f1;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 2px 5px rgba(0,0,0,0.05);
    text-align: center;
  }
  
  .label {
    display: block;
    font-size: 14px;
    color: #888;
  }
  
  .value {
    font-size: 28px;
    font-weight: bold;
    margin-top: 8px;
    color: #333;
  }
  @media (max-width: 600px) {
  .dashboard {
    padding: 20px;
  }

  .stat-box {
    padding: 16px;
  }

  .label {
    font-size: 13px;
  }

  .value {
    font-size: 24px;
  }
}
  </style>
  
